import SettingsPatternModalMyMenu from './SettingsPatternModalMyMenu';
export default SettingsPatternModalMyMenu;